import React, { useEffect } from 'react';

import { SlNavBarPositions, SlNavbarThemes } from '../../../features/shared/public/globalInterfaces/globalInterfaces';
import { SlDiscuss } from '../../../features/discuss/public/SlDiscuss/SlDiscuss';
import { SlNavbarState } from '../../../features/navigation/private/global-interface';
import { setNavigationConfigs } from '../../utils/navigationManager';

export const Discuss = React.memo(() => {
	useEffect(() => {
		setNavigationConfigs({
			state: SlNavbarState.shown,
			theme: SlNavbarThemes.light,
			position: SlNavBarPositions.relative,
		});

		return () => {
			setNavigationConfigs({
				state: SlNavbarState.hidden,
			});
		};
	}, []);

	return (
		<SlDiscuss />
	);
});
